<div [class.oculto]="modalAvisoPedidoSrv.ocultarModal || !modalAvisoPedidoSrv.avisosList.length"
     class="fondo-modal-mensajes">

    <div class="modal fade show"
         id="exampleModal"
         tabindex="-1"
         role="dialog"
         aria-labelledby="exampleModalLabel1"
         style="display: block;"
         (click)="cerrarModalClickOutside($event)">
        <div class="modal-dialog modal-dialog-scrollable custom-width"
             role="document">

            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title"
                        id="exampleModalLabel1">
                        <i class="fa fa-laptop"></i> Notificaciones del pedido <b>{{modalAvisoPedidoSrv.pedido?.pedido_cli }}</b> de {{modalAvisoPedidoSrv.pedido?.cliNombre }}
                    </h4>
                    <button type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close">
                        <span (click)="cerrarModal()"
                              aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">

                    <div class="row">
                        <div class="col-sm-12">
                            <div class="card card-body">
                                <table class="table table-striped table-sm">
                                    <thead>
                                        <tr>
                                            <th>Fecha</th>
                                            <th></th>
                                            <th>Mensaje</th>
                                            <th>Estado</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let aviso of modalAvisoPedidoSrv.avisosList">
                                            <td>{{aviso.created_at | date: 'dd/MM/yyyy HH:mm'}}</td>
                                            <td>
                                                <i *ngIf="aviso.tipo == 1"
                                                   class="fa-solid fa-message text-info"
                                                   title="Genérico"></i>
                                                <i *ngIf="aviso.tipo == 2"
                                                   class="fa-solid fa-receipt text-primary"
                                                   title="pedido"></i>
                                            </td>
                                            <td>{{aviso.mensaje}}</td>
                                            <td>
                                                <div class="text-center">
                                                    <i *ngIf="aviso.leido == 0"
                                                       class="fa-solid fa-envelope text-verde"
                                                       title="Sin leer"></i>
                                                    <i *ngIf="aviso.leido == 1"
                                                       class="fa-solid fa-envelope-open text-secondary"
                                                       title="Leido"></i>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>



                </div>
            </div>
        </div>
    </div>


</div>